import React from "react";
import TranslationWrapper, { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import { MenuItem, Select } from "@mui/material";
import { withStyles } from "tss-react/mui";
import productenStyle from "../../assets/jss/material-dashboard-pro-react/views/productStyle";

function OrderValueFilter(props) {
  const { classes } = props;

  let value = "ALL";

  if (props["metadata.orderValue"]?.operator === "=") {
    value = "0";
  } else if (props["metadata.orderValue"]?.operator === ">") {
    value = "1";
  }

  const orders = [
    {
      value: "ALL",
      label: getTranslation("bestellingen.filers.orders.all", "Alle orders"),
    },
    {
      value: "0",
      label: getTranslation("bestellingen.filers.orders.order0", "Orders met waarde 0"),
    },
    {
      value: "1",
      label: (
        <TranslationWrapper tDefault={"Order met waarde hoger dan 0"} tKey={"bestellingen.filers.orders.orderHoger0"} />
      ),
    },
  ];

  return (
    <Select
      MenuProps={{
        className: classes.selectMenu,
      }}
      classes={{
        select: classes.select,
      }}
      inputProps={{
        name: "simpleSelect",
        id: "simple-select",
        style: { paddingTop: "32px" },
      }}
      onChange={(e) => {
        switch (e.target.value) {
          case "ALL":
            props.setFilter("metadata.orderValue", null);
            break;
          case "0":
            props.setFilter("metadata.orderValue", {
              field: "metadata.orderValue",
              operator: "=",
              value: 0,
            });
            break;
          case "1":
            props.setFilter("metadata.orderValue", {
              field: "metadata.orderValue",
              operator: ">",
              value: 0,
            });
            break;
        }
      }}
      value={value}
    >
      {orders.map((item) => (
        <MenuItem
          classes={{
            root: classes.selectMenuItem,
            selected: classes.selectMenuItemSelected,
          }}
          key={item.value}
          value={item.value}
        >
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
}

const mapStateToProps = (state) => ({
  ["metadata.orderValue"]: state.filtersV2["metadata.orderValue"],
});

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(OrderValueFilter, productenStyle));
